module.exports = __webpack_public_path__ + "static/media/copy-link.ee4d4661.svg";